<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="row marginTop">
        <div class="col-md-8">
          <div class="bg-light">
            <v-toolbar color="primary" class="top-hero6" dark flat>
              <v-toolbar-title>Contact Us</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form v-model="valid">
                <div class="row">
                  <div class="col">
                    <v-text-field
                      :counter="10"
                      required
                      :rules="nameRules"
                      label="First Name"
                      name="name"
                      v-model="contact.first_name"
                      prepend-icon="mdi-account"
                      type="text"
                    ></v-text-field>
                  </div>

                  <div class="col">
                    <v-text-field
                      label="Last Name"
                      :rules="lastNameRules"
                      :counter="10"
                      required
                      name="last_name"
                      v-model="contact.last_name"
                      prepend-icon="mdi-account"
                      type="text"
                    ></v-text-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <v-text-field
                      required
                      label="Address"
                      name="address"
                      v-model="contact.address"
                      prepend-icon="mdi-account"
                      type="text"
                    ></v-text-field>
                  </div>

                  <div class="col">
                    <v-text-field
                      label="Email"
                      name="email"
                      :rules="emailRules"
                      required
                      v-model="contact.email"
                      prepend-icon="mdi-account"
                      type="email"
                    ></v-text-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <v-text-field
                      :rules="phoneRules"
                      :counter="12"
                      required
                      label="Phone Number"
                      name="phone"
                      v-model="contact.phone"
                      prepend-icon="mdi-account"
                      type="text"
                    ></v-text-field>
                  </div>

                  <div class="col">
                    Want to:
                    <span
                      class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800"
                    >
                      BUY
                    </span>
                  </div>
                </div>

                <v-textarea
                  v-model="contact.message"
                  required
                  :rules="messageRules"
                  :counter="150"
                  solo
                  label="Message"
                  rows="4"
                ></v-textarea>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="text-white"
                color="#42A5F5"
                :disabled="!valid"
                @click.prevent="sendMessage"
                >Send Message</v-btn
              >
            </v-card-actions>
          </div>
        </div>

        <div class="col-md-4">
          <v-card
            class="shadow"
            min-height="450"
            width="400"
            color="grey lighten-4"
          >
            <v-img :src="dataPreview.Images[0]"> </v-img>

            <v-card-text>
              <div class="font-weight-light grey--text title mb-2">
                {{ dataPreview.City }}<br />
                List Price: {{ dataPreview.ListPrice }}
              </div>

              <h3 class="display-1 font-weight-light blue--text mb-2">
                {{ dataPreview.StreetNumber }}
                {{ dataPreview.StreetName }}
                {{ dataPreview.StreetSuffix }}
              </h3>
              <v-divider></v-divider>

              <v-chip-group
                class="mt-2 text-center"
                active-class="grey darken-3 white--text"
                column
              >
                <v-chip
                  ><i class="m-1 text-secondary fas fa-align-justify"></i
                  ><b class="mr-1">Lot size: </b>
                  {{ dataPreview.LotSizeAcresRange }}</v-chip
                >
                <v-chip
                  ><i class="m-1 text-secondary fas fa-bath"></i
                  ><b class="mr-1">Bathroom: </b>
                  {{ dataPreview.BathroomsFull }}</v-chip
                >
                <v-chip
                  ><i class="m-1 text-secondary fas fa-bed"></i
                  ><b class="mr-1">Bedroom: </b>
                  {{ dataPreview.BedroomsTotal }}</v-chip
                >
              </v-chip-group>
            </v-card-text>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataPreview: "",
      valid: false,
      contact: {
        first_name: "",
        last_name: "",
        address:
          this.$route.params.listing.StreetNumber +
          " " +
          this.$route.params.listing.StreetName +
          " " +
          this.$route.params.listing.StreetSuffix,
        email: "",
        phone: "",
        selected: "Buy",
        message: ""
      },

      nameRules: [
        v => !!v || "Name is required",
        v => v.length <= 10 || "Name must be less than 10 characters"
      ],

      lastNameRules: [
        v => !!v || "Name is required",
        v => v.length <= 10 || "Name must be less than 10 characters"
      ],

      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],

      phoneRules: [
        v => !!v || "Phone is required",
        v => v.length <= 12 || "Phone must be less than 12 characters"
      ],

      messageRules: [
        v => !!v || "Name is required",
        v => v.length <= 150 || "Message must be less than 150 characters"
      ]
    };
  },

  computed: {
    fullAddress() {
      return (
        this.$route.params.listing.StreetNumber +
        this.$route.params.listing.StreetName +
        this.$route.params.listing.StreetSuffix
      );
    }
  },

  created() {
    this.dataPreview = this.$route.params.listing;
  },

  methods: {
    sendMessage() {
      window.axios.post("/api/messages", this.contact).then(() => {
        this.contact = {};
        alert("Message Sent");
        this.$router.push({ name: "Home" });
      });
    }
  }
};
</script>

<style>
#challange-target {
  display: none;
}

@media (max-width: 1026px) {
  #challange-target {
    display: block;
    margin-top: 65px;
    color: transparent;
  }
}
</style>
